// Steps the advisor can go live without. Kept here, next to the counting
// logic, so the hook and anything else that reports progress agree on what
// "mandatory" means.
export const NON_MANDATORY_STEPS = [
  'videoURL',
  'stripeAccountEnabled',
  'ycbmAccountConfirmed',
];

/**
 * Counts the mandatory steps rather than just answering "is anything missing".
 *
 * Turning "you have pending steps" into "4 of 6 done" is the difference between
 * a nag and a finishable task.
 *
 * @param {Object} missingSteps the `missingSteps` map from `whoAmI`, where a
 *   step is `true` once it is done
 */
export function summarizeSteps(missingSteps) {
  if (!missingSteps || typeof missingSteps !== 'object') {
    return { completed: 0, total: 0, percent: 0, pendingKeys: [] };
  }

  const mandatoryKeys = Object.keys(missingSteps).filter(
    (stepKey) => !NON_MANDATORY_STEPS.includes(stepKey)
  );
  const pendingKeys = mandatoryKeys.filter(
    (stepKey) => missingSteps[stepKey] === false
  );
  const completed = mandatoryKeys.length - pendingKeys.length;

  return {
    completed,
    total: mandatoryKeys.length,
    percent: mandatoryKeys.length
      ? Math.round((completed / mandatoryKeys.length) * 100)
      : 0,
    pendingKeys,
  };
}
